import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 3a21 21 0 0 1 0 18","key":"svg-0"}],["path",{"d":"M19 3a21 21 0 0 0 0 18","key":"svg-1"}],["path",{"d":"M5 12l14 0","key":"svg-2"}]]

const IconZodiacPisces = createReactComponent('outline', 'zodiac-pisces', 'ZodiacPisces', __iconNode);

export default IconZodiacPisces;